/**
 * Maps `?error=…` callback codes to user-facing copy. Sign-in failures
 * redirect to `/auth/error?error=…` or the UI root with a short
 * machine-readable code; unknown codes are humanized as-is.
 */
const FRIENDLY_MESSAGES: Record<string, string> = {
  invalid_saml_response:
    "The SAML response from your identity provider was invalid.",
  invalid_oidc_response:
    "The response from your identity provider was invalid.",
  signup_disabled: "No account was found for this user on this tenant.",
  sso_failed: "Sign-in with your identity provider failed. Try again.",
};

function humanize(code: string): string {
  const spaced = code.replace(/_/g, " ").trim();
  if (!spaced) return "Unknown error";
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}

/** User-facing text for auth callback query params (`error`, `error_description`). */
export function formatAuthCallbackError(
  error: string | null | undefined,
  errorDescription: string | null | undefined
): string {
  if (!error) return "Unknown error";

  const code = error.trim().toLowerCase().replace(/\s+/g, "_");

  const friendly = FRIENDLY_MESSAGES[code];
  if (friendly) return friendly;

  const humanized = humanize(error);
  if (errorDescription) return `${humanized}: ${errorDescription.trim()}`;
  return humanized;
}
